export default __webpack_public_path__ + "static/media/distortion_sl_results.c164eeaf.png";